import PatternIframe from "../../../../src/pages/pattern/component/PatternIframe.jsx";
import * as React from 'react';
export default {
  PatternIframe,
  React
};